import "core-js/modules/es.array.push.js";
import ScreeningDropdown from '@/components/data-picker/ScreeningDropdown';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
export default {
  components: {
    ScreeningDropdown,
    PopupDatePickerCpt
  },
  props: {
    /** 示例
     * searchItems: [
        {
          title: '赎回类型',
          type: 'flatSelect',
          name: 'redemptionType',
          mutiSelect: false,
          options: [
              {
                  key: '01',
                  value: '普通'
              },
              {
                  key: '02',
                  value: '计提'
              }
          ],
          selectedOptions: ["02"]
        },
        {
          title: '赎回状态',
          type: 'flatSelect',
          name: 'redemptionStatus',
          mutiSelect: true,
          options: [
              {
                  key: '01',
                  value: '赎回中'
              },
              {
                  key: '02',
                  value: '审核中'
              },
              {
                  key: '03',
                  value: '复核中'
              }
          ],
          selectedOptions: ["01", "02"]
        },
        {
          title: '产品',
          type: 'dropdown',
          name: 'productId',
          request: rqtPostFloatProductListForSelect,
          keyName: 'id',
          valueName: 'productName',
          selectedOptions: []
        },
        {
          title: '开放日',
          type: 'datePicker',
          name: 'productOpenDate',
          options: ["2021-01-01", "2021-02-02"]
          selectedOptions: []
        },
      ]
     */
    searchItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contentHeight: '',
      datePicker: {
        name: null,
        index: null
      }
    };
  },
  mounted() {
    let data = window.innerHeight + 'px';
    this.contentHeight = `calc(${data} - 30px - 50px - 20px`;
  },
  methods: {
    isSelected(name, value) {
      const item = this.searchItems.find(e => e.name == name);
      const selectedOption = item.selectedOptions.find(e => e == value);
      if (selectedOption) {
        return true;
      } else {
        return false;
      }
    },
    handleClick(name, key, mutiSelect) {
      const item = this.searchItems.find(e => e.name == name);
      const index = item.selectedOptions.findIndex(e => e == key);
      if (index >= 0) {
        item.selectedOptions.splice(index, 1);
      } else {
        if (mutiSelect) {
          item.selectedOptions.push(key);
        } else {
          item.selectedOptions = [key];
        }
      }
    },
    handleDropdownSelect(record, name) {
      const item = this.searchItems.find(e => e.name == name);
      item.selectedOptions = [record.id];
    },
    handleDropdownClear(name) {
      const item = this.searchItems.find(e => e.name == name);
      item.selectedOptions = [];
    },
    handleDateClick(name, index) {
      this.datePicker.name = name;
      this.datePicker.index = index;
      this.$refs.popupDatePickerCpt.showView();
    },
    onDatePickerSelectedChange(date) {
      const item = this.searchItems.find(e => e.name == this.datePicker.name);
      const dateArray = [...item.selectedOptions];
      dateArray[this.datePicker.index] = date;
      item.selectedOptions = dateArray;
      this.datePicker = {};
    },
    handleReset() {
      for (let searchItem of this.searchItems) {
        if (searchItem.type == 'flatSelect') {
          searchItem.selectedOptions = [];
        } else if (searchItem.type == 'dropdown') {
          //注意：v-for中的ref取出来是数组
          this.$refs['dropdown' + searchItem.name][0].clearValue();
        } else if (searchItem.type == 'datePicker') {
          searchItem.selectedOptions = [];
        } else if (searchItem.type == 'input') {
          searchItem.selectedOptions = [];
        }
      }
    },
    handleConfirm() {
      this.$emit('popSelectConfirm', this.searchItems);
    }
  }
};